var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-page-delete',{on:{"init":_vm.handleInit,"submit":_vm.handleSubmit}},[_c('Details',{attrs:{"itemData":_vm.itemData,"userData":_vm.userData}}),_c('Item',{attrs:{"itemData":_vm.itemData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }